export const BILL_ITEM_BEGIN_WRITE_DATA = 'BILL_ITEM/BEGIN_WRITE_DATA';
export const BILL_ITEM_COMPLETE_WRITE_DATA = 'BILL_ITEM/COMPLETE_WRITE_DATA';
export const BILL_ITEM_REQUEST_DATA = 'BILL_ITEM/REQUEST_DATA';
export const RECEIVE_BILL_ITEMS = 'BILL_ITEM/RECEIVE_BILL_ITEMS';
export const DELETE_BILL_ITEM_BY_ID = 'BILL_ITEM/DELETE_BILL_ITEM_BY_ID';
